import { cloneDeep, isEqual } from "lodash";
import { useRef } from "react";

// Provides a deep memoized value that will be stable according to lodash's isEqual function.
// Returns a cloned snapshot so callers like useDebouncedValue see a new reference when
// content changes even if the input object is mutated in place (as react-hook-form's
// watch() does).
export function useDeepMemo<T>(value: T): T {
  const snapshotRef = useRef<T>(cloneDeep(value));
  if (!isEqual(snapshotRef.current, value)) {
    snapshotRef.current = cloneDeep(value);
  }
  return snapshotRef.current;
}
